import { Directive, ElementRef, HostListener } from "@angular/core";
import { formatDocument } from "../pipes/document-format.pipe";

@Directive({ selector: "[appDocumentMask]" })
export class DocumentMaskDirective {
    constructor(private el: ElementRef) {}

    @HostListener("input")
    onInput(): void {
        const input = this.el.nativeElement as HTMLInputElement;
        input.value = formatDocument(input.value);
    }

    @HostListener("blur")
    onBlur(): void {
        const input = this.el.nativeElement as HTMLInputElement;
        input.value = input.value.toUpperCase();
    }
}
